"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pagePartsMayHoldId = pagePartsMayHoldId;
const page_document_maps_1 = require("./page-document-maps");
const page_part_summary_1 = require("./page-part-summary");
/** Unloaded content parts that cannot prove the requested id is absent. */
function pagePartsMayHoldId(directory, id, isUnloaded) {
    return [...directory]
        .filter(([partId, { m }]) => partId !== page_document_maps_1.PAGE_DOCUMENT_PART_ID &&
        isUnloaded(partId) &&
        (!m || (0, page_part_summary_1.pagePartMayHold)(m, id)))
        .map(([partId]) => partId);
}
